// extracted by mini-css-extract-plugin
module.exports = {"ThemeMain":"style_ThemeMain__ttHnW","active":"style_active__Vza6L","ThemeHead":"style_ThemeHead___C_DF","ThemeBody":"style_ThemeBody___xOo_","unactive":"style_unactive__aVNlZ"};